import { render, staticRenderFns } from "./TextWithLinks.vue?vue&type=template&id=f3f59442&"
import script from "./TextWithLinks.vue?vue&type=script&lang=js&"
export * from "./TextWithLinks.vue?vue&type=script&lang=js&"
import style0 from "./TextWithLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports